import { trackOffersHistoryFiltersChange } from './tracking';
import { selectFiltersStringified } from '../../../../selectors/offersHistory';
import { IThunkActionCreator } from '../../../../store';

export const trackFiltersChange = (): IThunkActionCreator => (_, getState) => {
  const state = getState();
  const filtersStr = selectFiltersStringified(state);

  trackOffersHistoryFiltersChange(filtersStr);
};
